import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import FieldsData from '../components/fields/FieldsData';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import useGetTrainingSet from '../components/hooks/useGetTrainingSet';
import TrainingSetHeader from '../components/train/TrainingSetHeader';
import TableStyles from '../components/documents/Table.module.css';
import { useParams } from 'react-router';

const FieldPage = () => {
  const { dpid, id } = useParams<{ dpid: string; id: string }>();
  const { loading, error } = useSetOrg(dpid);
  const { data: trainingSet } = useGetTrainingSet(id!);

  if (!id) {
    throw new Error("Missing 'id' parameter");
  }

  if (loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  return (
    <>
      <TopBar />
      <div className={TableStyles.extractionBatchHeaderWrapper}>
        <TrainingSetHeader trainingSet={trainingSet} dpid={dpid!} tsid={id} />
      </div>
      <div className={TableStyles.whiteContentWrapper}>
        <FieldsData trainingSetId={id} />
      </div>
    </>
  );
};

export default FieldPage;
